module.exports = __webpack_public_path__ + "img/Shape.06faf36a.svg";